import React, {useState} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as appActions from '../../../actions/applicationActionCreators';
import ChevronIcon from '../../Icons/Chevron';

import './style.scss';
import './mobile.scss';
import {Drawer} from 'antd';
import CloseIcon from '../../Icons/Close';
import MobileSearchString from '../../Header/Mobile/SearchString';


const CityContactsSelectCity = (props) => {
  const
    {cities, current_city, contactsCity, is_mobile} = props.applicationState,
    selectedCity = contactsCity || current_city,
    [open, setOpen] = useState(false),
    handleSelect = (id) => () => {
      props.applicationActions.fetchCityInfo(id);
      setOpen(false);
    },
    handleClose = () => {
      setOpen(false);
    };


  if (!cities?.length) {
    return null;
  }

  return is_mobile ? (
    <>
      <button className='contacts-select-city-button' onClick={() => setOpen(true)}>
        <span>{selectedCity.name}</span>
        <ChevronIcon direction='down'width={16} height={16} opacity='0.4' />
      </button>
      <Drawer
        className='select-drawer'
        getContainer='body'
        height='100%'
        placement='bottom'
        onClose={handleClose}
        title="Город"
        closeIcon={<CloseIcon />}
        open={open}
      >
        <div className='burger-menu-drawer__body'>
          <ul className='burger-menu-options select-city-mobile__list'>
            {
              cities.map((city) => (
                <li key={city.id} className={`burger-menu-option ${city.id === selectedCity.id ? 'burger-menu-option__active' : ''}`} onClick={handleSelect(city.id)}>
                  <span>{city.name}</span>
                  <span><ChevronIcon direction='right' opacity='.2'/></span>
                </li>
              ))
            }
          </ul>
        </div>
      </Drawer>

    </>
    ) : (
      <div className='left-menu-cities'>
        {
          cities.map((city) => {
            return (
              <button
                className={`left-menu-cities__item ${selectedCity.id === city.id ? 'selected' : ''}`}
                key={city.id}
                onClick={handleSelect(city.id)}
              >
                {city.name}
                <ChevronIcon direction='right' opacity='.2' />
              </button>
            )
          })
        }
      </div>
    );
}

const
  mapDispatchToProps = (dispatch) => {
    return {
      applicationActions: bindActionCreators(appActions, dispatch),
    };
  },
  mapStateToProps = ({applicationState}) => {
    return {
      applicationState
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default compose(withConnect)(CityContactsSelectCity);
